import React from 'react'
import {Avatar, Tooltip} from 'antd';
import {MdOutlineStickyNote2} from "react-icons/md";
import {AiOutlineUser} from "react-icons/ai";

import classes from './AnnouncementGridItem.module.css'

import {formatFioWithInitials, stringToDate} from '../../../../services/generalService';

import DynamicFilledButton from "../../../UI/DynamicFilledButton/DynamicFilledButton";


const AnnouncementGridItem = ({ scheduleType, date, note, startLessonTime, endLessonTime, employees, studentGroups,
                                  ifMobileGrid, auditory, shouldGrayOut }) => {

    const setGroupsLink = (group, index) => {
        const content = <DynamicFilledButton
            text={group.name}
            href={(group.name.indexOf('-') === -1) ? `/schedule/${group.name}` : `/schedule/${group.name.substr(0, group.name.indexOf('-'))}`}
            onClick={() => { localStorage.setItem('scheduleUrlId', JSON.stringify(group.name.substr(0, group.name.indexOf('-')))) }} />

        return <React.Fragment key={`groupWrapper${index}`}>
            <span key={`groupTooltip${index}`} className={classes.desktopLink}>
                <Tooltip placement="top" title={group.specialityCode + ' ' + group.specialityName + ' (' + group.numberOfStudents + ' студентов)'}>
                    <span style={{ display: 'inline-block' }}>{content}</span>
                </Tooltip>
            </span>
            <span key={`group${index}`} className={classes.mobileLink}>
                {content}
            </span>
        </React.Fragment>
    }

    const setEmployeeLink = (employee, index) => {
        const degreeAndRank = ` 
        ${(employee.degreeAbbrev || employee.rank) ? '(' : ''}${employee.degreeAbbrev ?? ''}${(employee.degreeAbbrev && employee.rank) ? ', ' : ''}${employee.rank ?? ''}${(employee.degreeAbbrev || employee.rank) ? ')' : ''}`

        const content = <DynamicFilledButton
            text={<React.Fragment>
                {formatFioWithInitials(employee)}
                {degreeAndRank}
            </React.Fragment>}
            href={`/schedule/${employee.urlId}`}
            onClick={() => { localStorage.setItem('scheduleUrlId', JSON.stringify(employee.urlId)) }}
            styles={{ width: 'fit-content', padding: '0 10px', textAlign: 'left' }} />

        return <React.Fragment key={`employeeWrapper${index}`}>
            <span key={`employeeTooltip${index}`} className={classes.desktopLink}>
                <Tooltip
                    placement="top"
                    title={<React.Fragment>
                        <div className={classes.avatarContainer}>
                            <Avatar
                                size={90}
                                src={employee.photoLink}
                                icon={<AiOutlineUser style={{ position: 'relative', top: '-5px' }} />} />
                        </div>
                        <div>{`${employee.lastName} ${employee.firstName} ${employee.middleName}`}</div>
                    </React.Fragment>}>
                    <span style={{ display: 'inline-block' }}>{content}</span>
                </Tooltip>
            </span>
            <span key={`employee${index}`} className={classes.mobileLink}>
                {content}
            </span>
        </React.Fragment>
    }

    const setAnnouncementTarget = () => {
        if (scheduleType === 2) return studentGroups.map((group, index) => setGroupsLink(group, index))
        if (scheduleType === 1) return employees.map((employee, index) => setEmployeeLink(employee, index))
        return null
    }

    return (
        <div
            className={classes.container}
            style={{ 
                maxWidth: ifMobileGrid ? '100%' : '240px',
                marginBottom: ifMobileGrid ? '10px' : '5px',
                opacity: shouldGrayOut ? 0.5 : 1
            }}>
            <div className={classes.title}>
                <MdOutlineStickyNote2 size={17} />
                <span>ОБЪЯВЛЕНИЕ</span>
            </div>
            <div>{note}</div>
            <div>
                <span>{`Дата: `}</span>
                <span className={classes.title}>{date}</span>
            </div>
            <div>
                <span>{`Время: `}</span>
                <span className={classes.title}>{`${startLessonTime} - ${endLessonTime}`}</span>
            </div>
            {auditory ?
                <div>
                    <span>{`Аудитория: `}</span>
                    <span className={classes.title}>{auditory}</span>
                </div> : ""
            }
            <div className={classes.announcementTargetContainer}>{setAnnouncementTarget()}</div>
        </div>
    )
}

export default AnnouncementGridItem;